export default __webpack_public_path__ + "static/media/inc.0aae8008.svg";